import React from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";

const Views = props => <VisibilityIcon {...props} />;

export default Views;
